import { render } from "./VisitModalDescriptionPart.vue?vue&type=template&id=c8bbb962&scoped=true"
import script from "./VisitModalDescriptionPart.vue?vue&type=script&lang=js"
export * from "./VisitModalDescriptionPart.vue?vue&type=script&lang=js"

import "./VisitModalDescriptionPart.vue?vue&type=style&index=0&id=c8bbb962&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c8bbb962"]])

export default __exports__